<template>
  <q-icon
    class="mira-spinner"
    :size="!isNaN(size) ? `${size}px` : size"
    :name="`img:${imagePath}`"
    :class="{'loading': loading}"
  />
</template>

<script>
// MIRA is here!
export default {
  props: {
    type: {
      type: String,
      default: 'symbol',
      validator: (value) => {
        return ['horizontal', 'vertical', 'symbol'].includes(value)
      }
    },
    size: {
      type: [String, Number],
      default: 60
    },
    dark: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    imagePath () {
      return `mira/${this.type}/svg/${this.dark ? 'miraLight' : 'miraBlue'}.svg`
    }
  }
}
</script>

<style scoped lang="scss">
@keyframes pulsate {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.25);
    opacity: 0.7;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.mira-spinner {
  &.loading {
    animation: pulsate 1.25s ease infinite;
  }
}
</style>
